function hideHeader() {
    if (!!document.querySelectorAll('.page-section')) {
        let pageSections = document.querySelectorAll('.page-section')
        pageSections.forEach(page => {
            if (!!page.getAttribute('data-hide-header')) {
                let shouldShow = page.getAttribute('data-hide-header')
                console.log(shouldShow);
                if (shouldShow === false || shouldShow === 'false') {
                    if (!!document.querySelector('store-header')) {
                        let headerElement = document.querySelector('store-header')
                        headerElement.style.display = 'none'
                    }
                }
            }
        })
    }
}

function changeIconWidth(){
    if (!!document.querySelectorAll('.text_content--usp')) {
        let calculateWidth = 0;
        let contentUsp = document.querySelectorAll('.text_content--usp')
        if (contentUsp.length == 3) {
            contentUsp.forEach(e=>{
                e.classList.add('text_content--full')
            })
            calculateWidth = 100 / contentUsp.length;
        } else if (contentUsp.length > 3) {
            calculateWidth = 50;
        } else {
            calculateWidth = 100 / contentUsp.length;
        }
        contentUsp.forEach(icon => {
            icon.style.width = calculateWidth + "%"
        })
    }
}

document.addEventListener("DOMContentLoaded", function (e) {
    hideHeader()
    changeIconWidth()
})